module.exports = __webpack_public_path__ + "static/media/loading.26ef8bb4.gif";